import type { MaybeRef } from "vue";

import { useEventListener } from "@vueuse/core";
import { ref, shallowRef, watchEffect } from "vue";

/**
 * Returns a boolean indicating whether the image has failed to load.
 * If the image is still loading, it has NOT failed (yet).
 * Use this with v-show, or you will get an infinite loop with the image element
 */
function useImageFailed(imageEl: MaybeRef<HTMLImageElement | null>) {
  const image = shallowRef(imageEl);
  const imageFailed = ref(false);

  function imageChanged(image: HTMLImageElement | null) {
    imageFailed.value = !!image && image.complete && image.naturalWidth === 0;
  }

  useEventListener(image, "load", () => imageChanged(image.value));
  useEventListener(image, "error", () => imageChanged(image.value));
  watchEffect(() => imageChanged(image.value));

  return imageFailed;
}

export { useImageFailed };
